import {Component, EventEmitter, Input, Output, ViewEncapsulation} from '@angular/core';

import {Alert} from '../../../delivery/models/alert.model';
import { TranslateContext } from '@shared/pipes/translate.pipe';

@Component({
	selector: 'amd-toolbar-widget',
	templateUrl: './toolbar-widget.component.html',
	styleUrls: ['./toolbar-widget.component.scss'],
	encapsulation: ViewEncapsulation.None
})
export class ToolbarWidgetComponent {
	@Input() alert: Alert;
	@Input() iconClass: string;
	@Input() counter: number;
	@Input() isAccent?: boolean;
	@Input() title: string;
	@Input() subTitle: string;
	@Input() showAction: boolean;
	@Input() showCustomAction: boolean = false;
	@Input() customAction: CustomActionModel;

	@Output() goToAlertDetailsEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();
	@Output() goToWriteNewAlertEventEmitter: EventEmitter<Event> = new EventEmitter<Event>();

	translateContext = TranslateContext;
}


export interface CustomActionModel {
	cta: string;
	icon?: string;
	action?: () => void;
}
